exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3HKQ-yq-ks5WQ2scsNSYHY{max-width:800px;margin:60px auto}a.hcip9ECj5IehFFx-i7oC0,a.hcip9ECj5IehFFx-i7oC0:hover,a.hcip9ECj5IehFFx-i7oC0:visited,a.hcip9ECj5IehFFx-i7oC0:active{color:#757575;text-decoration:none}@media screen and (max-width: 800px){._3HKQ-yq-ks5WQ2scsNSYHY{margin:0 auto}._3HKQ-yq-ks5WQ2scsNSYHY h1{margin:0 0;font-size:15px;line-height:1.5;text-align:center;font-weight:bold;padding:15px 0;border-bottom:1px solid #e0e0e0}}\n", ""]);

// Exports
exports.locals = {
	"NotificationsPage": "_3HKQ-yq-ks5WQ2scsNSYHY",
	"markAsRead": "hcip9ECj5IehFFx-i7oC0"
};